import ListSoldOrdersTable from './ListSoldOrdersTable';

export default ListSoldOrdersTable;
